// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2EHkU","tableContainer":"styles_tableContainer__3C_N9","loaderBox":"styles_loaderBox__33PW3","decisionsLoader":"styles_decisionsLoader__3XgXc"};